import React from 'react';
import materialTheme from '../../theme/materialTheme';
interface DessyIconProps {
  width?: string;
  height?: string;
  primaryColor?: string;
  accentColor?: string;
}

const DessyIcon: React.FC<DessyIconProps> = ({
  primaryColor = materialTheme.palette.primary.main,
  height = '56px',
  width = '56px',
}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width=""
      viewBox="0 0 1024 960"
      enableBackground="new 0 0 1024 960"
      xmlSpace="preserve"
      height={height}
      widths={width}
    >
      <path
        fill={primaryColor}
        opacity="1.000000"
        stroke="none"
        d="
M795.961304,44.816360 
	C816.437622,40.653893 836.393738,35.915867 856.586060,32.628300 
	C895.966614,26.216637 938.415466,47.654701 957.011658,82.881111 
	C973.883301,114.840866 975.121643,147.072357 957.568481,179.319489 
	C954.302002,185.320480 951.198853,191.394653 948.756897,197.792297 
	C942.325012,214.642761 930.137451,227.705811 919.422241,241.662979 
	C892.132263,277.209534 864.502869,312.495819 836.957397,347.845825 
	C821.292236,367.949493 805.523621,387.972656 789.806519,408.035919 
	C788.696472,409.453003 787.369507,410.743835 786.779541,413.155090 
	C795.033508,411.783813 802.957153,410.111694 811.022644,409.412567 
	C876.674622,403.721741 933.001526,441.097809 955.618225,497.914276 
	C959.820007,508.469818 962.844849,519.354187 964.436218,530.601868 
	C964.973328,534.398010 966.604675,535.845154 970.611023,535.846069 
	C978.236633,535.847778 983.577454,540.526855 984.288818,547.020691 
	C985.201355,555.350830 980.076416,561.014893 970.810608,561.220947 
	C966.789246,561.310425 965.560791,562.579651 965.090332,566.618408 
	C957.605591,630.868469 912.321106,679.497070 849.509827,691.003418 
	C793.434631,701.275757 736.711487,675.868286 705.773743,626.415833 
	C692.686646,605.496704 685.881775,582.533569 684.860413,557.903687 
	C684.683044,553.626953 683.111755,550.642090 678.888245,548.269287 
	C674.824219,553.322754 670.722595,558.292236 666.760193,563.370422 
	C630.585938,609.730591 594.487244,656.149780 558.263855,702.471497 
	C523.577515,746.827515 488.780640,791.097107 454.007324,835.385010 
	C443.322632,848.993103 432.616364,862.529785 422.696198,876.772705 
	C407.617798,898.421509 385.734467,910.825623 359.882721,914.917114 
	C324.929779,920.449097 294.614960,910.294800 269.914429,884.709961 
	C259.709717,874.139893 253.006439,861.325562 247.677628,847.680786 
	C214.541580,762.834473 181.338638,678.014221 148.076248,593.217285 
	C114.265991,507.023682 80.502617,420.811035 46.365124,334.746979 
	C40.394455,319.694305 35.677948,304.595428 35.838566,288.339111 
	C36.350216,236.554382 73.887726,197.523422 116.759300,189.394196 
	C150.588730,182.979538 184.096954,174.883072 217.785706,167.711411 
	C272.651672,156.031509 327.552765,144.516739 382.431061,132.894669 
	C428.665833,123.103119 474.895935,113.289116 521.116333,103.429893 
	C602.665344,86.034767 684.204834,68.594910 765.750000,51.181618 
	C775.677368,49.061726 785.614990,46.990238 795.961304,44.816360 
M941.517761,604.061951 
	C956.127991,569.927551 956.915710,535.502075 942.652954,501.188507 
	C913.318909,430.615601 833.029846,404.669708 769.210632,434.590668 
	C765.662598,436.254120 762.821411,438.557678 760.405518,441.703674 
	C741.845764,465.872223 723.195129,489.971161 704.497192,514.033020 
	C702.709839,516.333191 701.353882,518.695068 700.814331,521.546265 
	C696.771667,542.907288 696.334839,564.201050 702.172729,585.338806 
	C719.635498,648.567566 781.337158,689.429382 846.137146,677.679626 
	C890.173828,669.694702 921.979980,645.314819 941.517761,604.061951 
M808.013428,361.534851 
	C844.404480,314.866302 880.795532,268.197754 917.186523,221.529190 
	C906.628845,225.590622 896.464600,229.177948 885.843140,231.423050 
	C851.327942,238.718643 816.831421,246.105179 782.272949,253.189911 
	C777.189575,254.232010 774.784973,256.236298 773.677002,261.515137 
	C770.463135,276.827057 764.117188,290.965027 755.255737,303.852600 
	C732.657288,336.718323 701.059326,357.868256 664.763489,372.797607 
	C664.234497,373.015198 663.537720,372.824738 662.159119,372.824738 
	C664.589111,367.490265 666.840576,362.594513 669.053650,357.681427 
	C679.957520,333.474701 683.713318,308.364777 678.724792,282.107513 
	C677.967407,278.120972 676.913879,275.777710 671.910217,276.945374 
	C657.483276,280.312042 642.960938,283.276398 628.448181,286.263214 
	C625.578796,286.853760 623.807373,288.495453 622.111816,290.673828 
	C592.539856,328.666260 562.907898,366.611969 533.363525,404.625824 
	C531.607727,406.885010 529.191711,408.882660 528.660034,412.121124 
	C588.933655,431.276398 623.122131,472.600861 633.199341,534.433716 
	C634.403625,534.238403 635.095520,534.267395 635.660706,534.013794 
	C647.425354,528.735779 659.517700,526.826904 672.157410,530.372925 
	C673.569336,530.769043 674.975159,530.607117 675.789368,529.414124 
	C681.012268,521.761536 688.621704,515.724182 691.540222,506.517548 
	C702.448669,472.106537 723.454468,445.825958 754.768921,427.823883 
	C756.529480,426.811768 758.017212,425.546448 759.271545,423.939026 
	C775.363892,403.317139 791.476990,382.711456 808.013428,361.534851 
M397.753662,638.748108 
	C436.490173,679.678406 495.813660,691.742188 545.666260,667.321716 
	C594.646423,643.328735 619.550476,603.058716 619.786072,548.520264 
	C620.039124,489.950378 579.966980,439.314850 523.351929,424.906342 
	C519.416382,423.904816 516.955200,424.599091 514.384460,427.885651 
	C468.939240,485.984650 423.401611,544.011475 377.765991,601.960999 
	C375.698975,604.585815 375.938293,606.409180 377.276367,609.064758 
	C382.634979,619.699707 389.350922,629.370178 397.753662,638.748108 
M334.779968,517.845825 
	C336.537476,522.338379 338.504150,526.763184 339.988617,531.344177 
	C341.257599,535.260071 344.112427,535.052979 347.187317,534.921021 
	C350.493622,534.779114 350.593628,532.472107 350.772278,530.017151 
	C350.904358,528.202209 351.342560,526.406433 351.688477,524.610596 
	C361.881409,471.694183 392.232330,435.428101 442.374756,416.084381 
	C461.896729,408.553253 482.439392,406.546204 503.330109,408.514709 
	C507.159515,408.875549 510.952606,409.847595 514.156494,405.738586 
	C541.909119,370.145874 569.865967,334.712463 597.721863,299.200134 
	C598.889160,297.712006 600.675842,296.404663 600.298950,293.997833 
	C598.257935,292.442047 596.144287,293.427856 594.119507,293.860352 
	C544.977600,304.356781 495.843475,314.889679 446.704407,325.399353 
	C391.710815,337.161072 336.711151,348.894440 281.721252,360.673279 
	C274.548035,362.209808 274.529449,362.315826 277.138123,369.055267 
	C296.244019,418.415466 315.366486,467.769226 334.779968,517.845825 
M479.359344,692.307129 
	C441.860016,688.887512 410.450134,673.075989 384.669006,645.579041 
	C400.183136,683.682800 414.706848,721.966614 429.562347,760.120239 
	C434.632660,773.142334 440.369934,785.952271 442.686981,799.874207 
	C444.025970,807.919434 443.087402,816.080078 443.498138,825.892639 
	C483.633789,774.689331 522.859497,724.646912 562.662231,673.868286 
	C536.418457,688.448730 509.357910,694.988892 479.359344,692.307129 
M483.222961,444.746887 
	C488.983185,437.298676 494.743408,429.850494 500.721313,422.120819 
	C459.708344,417.570312 408.859436,436.370819 380.566132,483.535797 
	C358.997406,519.490967 359.863129,568.227600 370.350067,588.454834 
	C407.941803,540.593384 445.362549,492.949585 483.222961,444.746887 
M629.679871,586.092041 
	C629.908447,586.276062 630.160706,586.630981 630.359924,586.603394 
	C630.643738,586.564026 630.944763,586.288086 631.141968,586.037415 
	C640.084717,574.669556 649.019714,563.295654 657.948486,551.916870 
	C660.272583,548.954956 662.573669,545.974976 665.347534,542.409241 
	C654.085510,540.462952 644.807556,542.818970 636.632751,549.449341 
	C634.522461,551.160889 633.211548,553.425720 633.246338,556.369141 
	C633.363098,566.242188 631.245911,575.856995 629.679871,586.092041 
z"
      />
      <path
        fill={primaryColor}
        opacity="1.000000"
        stroke="none"
        d="
M756.420898,746.674316 
	C760.568970,754.082031 759.805298,759.121887 753.221436,763.910767 
	C732.847656,778.730530 710.260803,788.818420 685.427917,793.062927 
	C640.899414,800.673767 599.706604,791.801758 562.174072,766.505615 
	C559.841675,764.933716 557.539001,763.195557 555.617798,761.161499 
	C551.805481,757.125122 551.451477,751.730530 554.347656,747.402039 
	C557.144592,743.221863 562.553345,741.446899 567.636169,743.295776 
	C569.479065,743.966125 571.215149,745.071899 572.823181,746.225464 
	C623.238098,782.390503 688.315186,782.401855 739.169617,746.221252 
	C746.091064,741.296997 750.430237,741.335266 756.420898,746.674316 
z"
      />
    </svg>
  );
};

export default DessyIcon;
